import React, {
    useEffect,
    useState
} from "react";

import axios from "axios";

import "./Profile.css";

import IgniteNavbar
    from "../../layout/IgniteNavbar";

import IgniteHeader
    from "../../layout/IgniteHeader";

import ProfileHero
    from "./Components/ProfileHero";

import PerformanceSummary
    from "./Components/PerformanceSummary";

import AccountInformation
    from "./Components/AccountInformation";


const Profile = () => {

    /* =====================================================
       EMAIL
    ===================================================== */

    const email =
        localStorage.getItem(
            "user_email"
        );


    /* =====================================================
       STATES
    ===================================================== */

    const [
        profileData,
        setProfileData
    ] = useState(null);


    const [
        dashboard,
        setDashboard
    ] = useState(null);


    const [
        profilePhoto,
        setProfilePhoto
    ] = useState(
        localStorage.getItem(
            "profile_photo"
        ) || ""
    );


    const [
        loading,
        setLoading
    ] = useState(true);
     useEffect(() => {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }, []);

    /* =====================================================
       HIDE MAIN WEBSITE NAVBAR / FOOTER
    ===================================================== */

    useEffect(() => {

        const navbar =
            document.querySelector(
                "header, .navbar"
            );

        const footer =
            document.querySelector(
                "footer"
            );


        if (navbar) {

            navbar.style.display =
                "none";

        }


        if (footer) {

            footer.style.display =
                "none";

        }


        return () => {

            if (navbar) {

                navbar.style.display =
                    "";

            }


            if (footer) {

                footer.style.display =
                    "";

            }

        };

    }, []);


    /* =====================================================
       LOAD PROFILE
    ===================================================== */

    useEffect(() => {

        if (!email) {

            setLoading(false);

            return;

        }


        loadProfile();

    }, [email]);


    /* =====================================================
       FETCH PROFILE
    ===================================================== */

    const loadProfile = async () => {

        try {

            setLoading(true);


            const [
                profileRes,
                dashboardRes
            ] = await Promise.all([

                axios.get(
                    `/api/ignite/profile/${encodeURIComponent(
                        email
                    )}`
                ),

                axios.get(
                    `/api/dashboard/${encodeURIComponent(
                        email
                    )}`
                )

            ]);


            console.log(
                "================================="
            );

            console.log(
                "PROFILE API RESPONSE:",
                profileRes.data
            );

            console.log(
                "================================="
            );


            /* =================================================
               PROFILE RESPONSE
            ================================================= */

            const profile =
                profileRes.data;


            setProfileData(
                profile
            );


            /* =================================================
               GET USER
            ================================================= */

            const user =
                profile?.user ||
                profile?.profile ||
                profile;


            console.log(
                "PROFILE USER:",
                user
            );


            /* =================================================
               GET PROFILE PHOTO
            ================================================= */

            const photo =
                user?.profilePhoto ||
                profile?.profilePhoto ||
                "";


            console.log(
                "================================="
            );

            console.log(
                "PROFILE PHOTO:",
                photo
            );

            console.log(
                "================================="
            );


            if (photo) {

                setProfilePhoto(
                    photo
                );


                localStorage.setItem(
                    "profile_photo",
                    photo
                );

            }


            /* =================================================
               LEVEL
            ================================================= */

            const userLevel =
                Number(
                    user?.level ||
                    profile?.level ||
                    dashboardRes.data?.level ||
                    1
                );


            localStorage.setItem(
                "user_level",
                String(
                    userLevel
                )
            );


            /* =================================================
               PROFILE UPDATED EVENT
            ================================================= */

            window.dispatchEvent(

                new CustomEvent(
                    "profileUpdated",
                    {
                        detail: {
                            photo,
                            level:
                                userLevel
                        }
                    }
                )

            );


            /* =================================================
               DASHBOARD
            ================================================= */

            setDashboard(
                dashboardRes.data
            );

        }

        catch (err) {

            console.error(
                "PROFILE LOAD ERROR:",
                err
            );

        }

        finally {

            setLoading(false);

        }

    };


    /* =====================================================
       LOADING
    ===================================================== */

    if (loading) {

        return (

            <div className="ignite-profile-page">

                <IgniteNavbar />

                <main className="ignite-profile-main">

                    <IgniteHeader

                        title="Profile"

                        subtitle="Manage your Ignite profile."

                    />

                    <div className="profile-loading">

                        Loading Profile...

                    </div>

                </main>

            </div>

        );

    }


    /* =====================================================
       RENDER
    ===================================================== */

    return (

        <div className="ignite-profile-page">

            <IgniteNavbar />

            <main className="ignite-profile-main">

                <IgniteHeader

                    title="Profile"

                    subtitle="Manage your personal information and achievements."

                    profilePhoto={
                        profilePhoto
                    }

                />


                {/* =================================================
                    PROFILE HERO
                ================================================= */}

                <ProfileHero

                    data={
                        profileData
                    }

                    profilePhoto={
                        profilePhoto
                    }

                    refreshProfile={
                        loadProfile
                    }

                />


                {/* =================================================
                    PERFORMANCE
                ================================================= */}

                <div className="profile-section">

                    <PerformanceSummary

                        data={
                            profileData
                        }

                        dashboard={
                            dashboard
                        }

                    />

                </div>


                {/* =================================================
                    ACCOUNT
                ================================================= */}

                <div className="profile-section">

                    <AccountInformation

                        data={
                            profileData
                        }

                        refreshProfile={
                            loadProfile
                        }

                    />

                </div>

            </main>

        </div>

    );

};


export default Profile;